import IFolder from "../../models/IFolder";
import { NIL as empty } from "uuid";

const newFolder = (isPersonal: boolean, parentFolderId?: string): IFolder => ({
    id: empty,
    name: "",
    parentId: parentFolderId,
    isPersonal,
    audience: [],
    attributes: []
});

export default newFolder;